import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=5c1984bc&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"
import style0 from "./Widget.vue?vue&type=style&index=0&id=5c1984bc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1984bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\laragon\\www\\elipse-citas\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c1984bc')) {
      api.createRecord('5c1984bc', component.options)
    } else {
      api.reload('5c1984bc', component.options)
    }
    module.hot.accept("./Widget.vue?vue&type=template&id=5c1984bc&scoped=true", function () {
      api.rerender('5c1984bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Home/Widget.vue"
export default component.exports